import { render, staticRenderFns } from "./List_.vue?vue&type=template&id=feca5cae&"
import script from "./List_.vue?vue&type=script&lang=js&"
export * from "./List_.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports